import { EnvConfig } from '../../config/EnvConfig'

const affiseScript = (onLoad) => {
  const script = document.createElement('script')
  script.src = `${EnvConfig.GATSBY_AFFISE_TRACKING_URL}/websdk.js`
  script.async = true
  script.defer = true
  script.onload = onLoad

  return script
}

export default affiseScript
